export default __webpack_public_path__ + "static/fin-identity-bio-9ec7ee5949799649901efec1f65b2c97.png";